<template lang="pug">
  section(class="separable", v-if="conversa")
    div(class="container")
      el-row
        el-col(:span="24")
          div(class="card")
            div(class="card-header") {{ conversa.assunto }}
            div(class="card-body")
              app-collapse(
                v-for="(mensagem, index) in conversa.mensagemList",
                :key="mensagem.id",
                :title="mensagem.nomeRemetente + ' - ' + mensagem.dataEnviadaFormatada"
                :collapsed="index < (conversa.mensagemList.length - 1) ? '1' : '0'"
              )
                p(v-html="mensagem.conteudo")

                el-row
                  el-table(
                    :data='mensagem.anexoList',
                    stripe
                  )
                    div(slot='empty')
                      span Não há anexos disponíveis.
                    el-table-column.td-column-anexo(
                      prop='nome',
                    )
                    el-table-column.td-column-anexo(
                      align="center",
                      width="85"
                    )
                      template(slot-scope='scope')
                        app-action-button(
                          icone="download",
                          nome="file_download",
                          @click="baixarAnexo(scope.row)",
                          hoverColor="#009f61",
                          text="Baixar anexo"
                        )
</template>

<script>
import AppActionButton from '../../../../components/AppActionButton'
import AppCollapse from '@/components/AppCollapse'

export default {

  components: {
    AppActionButton,
    AppCollapse
  },

  props: {
    conversa: {
      required: true
    }
  },

  methods: {
    baixarAnexo (data) {
      this.$store.commit('loader/SET_LOADER')
      this.$store.dispatch('conversas/baixarDocumento', {
        id: data.id,
        nome: data.nome
      })
        .then(() => {
          this.$store.commit('loader/RESET_LOADER')
        }).catch(() => {
          this.$store.commit('loader/RESET_LOADER')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .conteudo {
    margin: 0px 15px;
    text-align: left;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
  }

  .dataLimite {
    margin-top: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: 400;
  }

  .card {
    margin-top: 0;
  }

  .card .card-header {
    font-size: x-large;
    line-height: initial;
    padding: 23px 23px 0 23px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/central/components/centralMensagens/AppVisualizarConversa.vue